import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const ThemeProvider = ({ children, themeProducer }) => {
    // 21.3.2 is replaced by the build process
    const { tokensString, themeClassName } = themeProducer('21.3.2');
    return (jsxs(Fragment, { children: [jsx("style", { children: tokensString }), jsx("div", { className: themeClassName, children: children })] }));
};

export { ThemeProvider };
//# sourceMappingURL=ThemeProvider.js.map
